import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createFollowedChannelRequest = { followedChannel: '_followedChannel' };
var _createFollowedChannelResponse = { followedChannel: '_followedChannel' };
var _followedChannel = { createdDate: 'google.protobuf.Timestamp' };
var _listFollowedChannelsRequest = {};
var _listFollowedChannelsResponse = { followedChannels: '_followedChannel' };
function resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/loyalty-social-media',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-social-media',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-social-media',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-social-media',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-social-media',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-social-media',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates an entity for the specified account ID when the account follows a social media channel.
 *
 * Members can only follow enabled channels. A Wix user has to enable channels in the dashboard.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function createFollowedChannel(payload) {
    var _a = serializer(_createFollowedChannelRequest, { _followedChannel: _followedChannel }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFollowedChannelResponse, {
        _followedChannel: _followedChannel,
    }).fromJSON;
    function __createFollowedChannel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.socialmedia.v1.followed_channel',
            method: 'POST',
            methodFqn: 'wix.loyalty.socialmedia.v1.LoyaltySocialMedia.CreateFollowedChannel',
            url: resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl({
                protoPath: '/v1/followed-channels',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFollowedChannel.fromReq = fromReq;
    __createFollowedChannel.__isAmbassador = true;
    return __createFollowedChannel;
}
/**
 * Retrieves a list of social media channels followed by the account. The list is ordered by creation date.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function listFollowedChannels(payload) {
    var _a = serializer(_listFollowedChannelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFollowedChannelsResponse, {
        _followedChannel: _followedChannel,
    }).fromJSON;
    function __listFollowedChannels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.socialmedia.v1.followed_channel',
            method: 'GET',
            methodFqn: 'wix.loyalty.socialmedia.v1.LoyaltySocialMedia.ListFollowedChannels',
            url: resolveWixLoyaltySocialmediaV1LoyaltySocialMediaUrl({
                protoPath: '/v1/followed-channels',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFollowedChannels.fromReq = fromReq;
    __listFollowedChannels.__isAmbassador = true;
    return __listFollowedChannels;
}
//# sourceMappingURL=http.impl.js.map